<template>
	<div id="app">		
		<Header></Header>
		<router-view />
		<Footer></Footer>
	</div>
</template>

<script>
	import Header from '@/components/Header/index.vue'
	import Footer from '@/components/Footer.vue'
	import {
		mapMutations,
	} from 'vuex'
	import '@/assets/css/public.css';
	export default {
		data() {
			return {

			}
		},
		created() {

		},
		mounted() {
			this.set()
			window.onresize = () => {
				return (() => {
					this.set()
				})()
			}
		},
		computed: {},
		watch: {},
		methods: {
			...mapMutations(['setIsMobile']),
			set() {
				if (document.body.clientWidth < 768) {
					this.setIsMobile(true)
					document.documentElement.style.fontSize = 100 + 'px';
				} else {
					this.setIsMobile(false)
					document.documentElement.style.fontSize = 14 + 'px';
				}
			}
		},
		components: {
			Header,Footer
		}
	}
</script>

<style scoped lang="less">

</style>
